var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStarFilledShadow = function SvgStarFilledShadow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "#1098fc",
    xmlns: "http://www.w3.org/2000/svg",
    accessibilityRole: "image"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 48,
    height: 48,
    rx: 24,
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6595 13.305L28.8593 17.7404C29.1593 18.3578 29.9592 18.9501 30.6341 19.0635L34.6212 19.7313C37.1709 20.1597 37.7708 22.0246 35.9335 23.8643L32.8339 26.9892C32.3089 27.5184 32.0215 28.539 32.1839 29.2699L33.0713 33.1382C33.7713 36.2002 32.1589 37.3846 29.4717 35.7843L25.7346 33.554C25.0597 33.1508 23.9473 33.1508 23.2599 33.554L19.5228 35.7843C16.8481 37.3846 15.2233 36.1876 15.9232 33.1382L16.8106 29.2699C16.9731 28.539 16.6856 27.5184 16.1607 26.9892L13.061 23.8643C11.2362 22.0246 11.8237 20.1597 14.3734 19.7313L18.3605 19.0635C19.0229 18.9501 19.8228 18.3578 20.1228 17.7404L22.3225 13.305C23.5224 10.8983 25.4722 10.8983 26.6595 13.305Z"
  })));
};
export default SvgStarFilledShadow;